<template>
  <b-modal
    v-model="data.showModal"
    size="xl"
    button-size="sm"
    modal-class="template-modal"
    title-class="w-100"
    footer-class="w-100"
    no-fade
    @show="onShow"
    @hide="onHide"
  >
    <!-- Modal header -->
    <div slot="modal-title">
      <div class="d-flex w-100 justify-content-between">
        Export
      </div>
    </div>

    <!-- Modal content -->
    <div class="d-flex flex-column gap-2">
      <div>
        <div v-if="isLoading && exportFilters === null">Loading filters..</div>
         <b-form-group
           v-for="exportFilter in exportFilters"
           :key="exportFilter.id"
           label-cols="3"
           label-size="sm"
           :label="exportFilter.field_name"
          >
            <v-select
              v-if="exportFilter.field_type === 'text'"
              v-model="exportFilter.value"
              :options="exportFilter.options"
              :clearable="true"
              @input="fetchCount()"
            >
            </v-select>
            <button-select
              v-if="exportFilter.field_type === 'boolean'"
              v-model="exportFilter.value"
              :options="options.boolean_value"
              size="sm"
              @input="fetchCount()"
            />
          </b-form-group>
      </div>
    </div>

    <!-- Modal footer -->
    <div slot="modal-footer" class="w-100 d-flex gap-4 justify-content-between align-items-center">
      <div class="d-flex w-100 justify-content-between">
        <div>
          <span v-if="exportCount === null">
            Loading..
          </span>
          <span v-else>
            Found <span class="font-weight-bold">{{ exportCount | format }}</span> item(s)
          </span>
        </div>
        <div class="d-flex gap-2 align-items-center">
          <b-form-input
            v-model="exportTitle"
            size="sm"
            autocomplete="off"
            placeholder="Title"
          ></b-form-input>
          <b-btn
            size="sm"
            variant="primary"
            :disabled="isLoading || (exportCount === null || exportCount === 0)"
            @click="onExport()"
          >
            Export
          </b-btn>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
const ButtonSelect = () => import('@/components/global/ButtonSelect.vue');

export default {
  name: 'ExportData',
  components: {
    ButtonSelect,
  },
  props: {
    data: Object,
  },
  computed: {
    isLoading() {
      return this.loadingCount > 0;
    },
    canSave() {
      return true;
    },
    preventMessage() {
      return 'You have unsaved changes. Are you sure you want to close?';
    },
    preventClose() {
      return false;
    },
  },
  data() {
    return {
      loadingCount: 0,
      filters: {},
      options: {
        boolean_value: [
          { text: 'All', value: null },
          { text: 'Yes', value: true },
          { text: 'No', value: false },
        ],
      },
      exportTitle: '',
      exportFilters: null,
      exportCount: null,
      exportUrl: null,
    };
  },
  methods: {
    fetchTitle() {
      this.loadingCount++;
      this.$http.get(`/feed_export/${this.data.feedId}/exports/${this.data.exportId}`)
        .then((res) => {
          this.exportTitle = res.body.title;
        })
        .catch((err) => {
          alert(`Failed to fetch title: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchFilters() {
      this.loadingCount++;
      this.$http.get(`/feed_export/${this.data.feedId}/exports/${this.data.exportId}/filters`)
        .then((res) => {
          this.exportFilters = res.body.map((filter) => {
            if (filter.field_type === 'text') {
              filter.value = '';
            }
            if (filter.field_type === 'boolean') {
              filter.value = null;
            }
            return filter;
          });
        })
        .catch((err) => {
          alert(`Failed to fetch filters: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    fetchAll() {
      this.fetchTitle();
      this.fetchFilters();
      this.fetchCount();
    },
    fetchCount() {
      this.loadingCount++;
      this.exportCount = null;
      this.$http
        .post(`/feed_export/${this.data.feedId}/exports/${this.data.exportId}/exportCount`)
        .send({ filters: this.exportFilters })
        .then((res) => {
          this.exportCount = res.body;
        })
        .catch((err) => {
          alert(`Count failed: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    onExport() {
      this.loadingCount++;
      this.$http
        .post(`/feed_export/${this.data.feedId}/exports/${this.data.exportId}/export`)
        .send({ filters: this.exportFilters, exportTitle: this.exportTitle })
        .then((res) => {
          this.exportUrl = res.body;
          if (res.body !== null) {
            const link = document.createElement('a');
            link.href = res.body;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.onClose();
          }
        })
        .catch((err) => {
          alert(`Export failed: ${err.response.text}`);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },
    onSave() {
      // Implement logic
    },
    onShow() {
      this.fetchAll();
    },
    onClose() {
      this.data.showModal = false;
      this.$emit('close');
    },
    onHide(event) {
      if (this.preventClose && !confirm(this.preventMessage)) {
        event.preventDefault();
        return;
      }
      this.exportTitle = '';
      this.exportFilters = null;
      this.exportUrl = null;
      this.exportCount = null;
    },
  },
};
</script>

<style lang="scss">
</style>
